<template>
  <div class="group-rounded-box my-0 mx-4">
    <div class="row">
      <div class="col-md-12">
        <div class="table-container table-responsive">
          <div v-if="priceQuotes.length === 0" class="w-100 alert alert-secondary mt-3 text-center">
            <i class="fas fa-info-circle mr-2"></i>
            You have not created any price quotes
          </div>
          <table v-else class="table no-border">
            <thead>
              <tr>
                <th v-for="(item, key) of tableTitles" :key="key">
                  {{ item.title }}
                </th>
              </tr>
            </thead>
            <tbody v-for="(priceQuote, priceQuoteKey) of priceQuotesFormatted" :key="priceQuoteKey">
              <tr v-for="(item, itemKey) of priceQuote.basketItems" :key="itemKey">
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  {{ priceQuote.customerName }}
                </td>
                <template v-if="priceQuote.terminalId">
                  <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                    {{ priceQuote.terminalId | terminalsname }}
                  </td>
                </template>
                <td class="p-1" v-else>{{ item.networkId | networksname }}</td>
                <td>{{ item.productId | fueltype }}</td>
                <td>{{ item | liftingperiodformat }}</td>
                <td>{{ item.fuelMeasurementId | fuelmeasurementtype }}</td>
                <td>{{ item.quantity | volumeformat }}</td>
                <td class="p-1">{{ item.quotePrice | priceformat }}</td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  <span v-if="priceQuote.status !== ePriceQuoteStatus.open" 
                  :class="{'text-primary': priceQuote.status === ePriceQuoteStatus.orderPlaced,
                            'text-danger': priceQuote.status === ePriceQuoteStatus.expired}"> 
                  {{ priceQuote.status }} 
                  </span>
                  <price-quote-countdown
                    v-else
                    :startTime="priceQuote.timeLeft"
                    :priceQuoteId="priceQuote._id"
                    @set-to-expired="setPriceQuoteStatusToExpired"
                  ></price-quote-countdown>
                </td>
                <td v-if="itemKey === 0" :rowspan="priceQuote.basketItems.length">
                  <button
                    :class="{
                      invisible:
                        priceQuote.status === ePriceQuoteStatus.expired ||
                        priceQuote.status === ePriceQuoteStatus.orderPlaced,
                    }"
                    @click="$emit('add-to-basket', priceQuote._id)"
                    class="btn btn-sm btn-primary"
                  >
                    Add to Basket
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eBasketStatus } from "@/util/enums/basket"

import PriceQuoteCountdown from "./PriceQuoteCountdown.vue";

export default {
  components: { PriceQuoteCountdown },
  data() {
    return {
      priceQuotesFormatted: [],
      tableTitles: [
        { title: "Customer" },
        { title: "Terminal" },
        { title: "Product" },
        { title: "Lifting Period" },
        { title: "Measurement" },
        { title: "Volume/L" },
        { title: "Price ppl" },
        { title: "Expiry" },
        { title: "Add" },
      ],
      ePriceQuoteStatus: {
        open: "open",
        expired: "expired",
        orderPlaced: "order placed"
      },
      eBasketStatus
    };
  },
  props: {
    priceQuotes: {
      type: Array,
      required: true,
    },
  },
  watch: {
    priceQuotes: {
      handler: function (priceQuotesList) {
        this.priceQuotesFormatted = this.formatPriceQuotes(priceQuotesList);
      },
    },
  },
  computed: {
    ...mapGetters("accounts", ["customerList"]),
  },
  methods: {
    formatPriceQuotes: function (priceQuotesList) {
      return priceQuotesList
        .map(({ _id, basket, expires }) => {
          const { account_id, status: basketStatus } = basket;
          const { name: customerName = "-" } = this.customerList.find(({ id }) => id === account_id) || {};
          const terminalId = basket.items[0].terminalId;
          const timeLeft = (new Date(expires) - new Date()) / 1000;

          const basketItems = basket.items.map((item) => {
            const { price, adjustment } = item;
            return { ...item, quotePrice: price + adjustment };
          });
          
          return { _id, customerName, terminalId, basketItems, timeLeft, status: this.setPriceQuoteStatus(basketStatus, timeLeft) };
        })
        .sort((first, second) => -(first.timeLeft - second.timeLeft));
    },
    setPriceQuoteStatus: function (basketStatus, timeLeft) {
      if (basketStatus === eBasketStatus.Ordered) {
        return this.ePriceQuoteStatus.orderPlaced;
      }
      if (timeLeft < 1) {
        return this.ePriceQuoteStatus.expired;
      }
      return this.ePriceQuoteStatus.open;
    },
    setPriceQuoteStatusToExpired(priceQuoteId) {
      const expiredPriceQuote = this.priceQuotesFormatted.find(({ _id }) => _id === priceQuoteId);
      if (expiredPriceQuote) {
        expiredPriceQuote.status = this.ePriceQuoteStatus.expired;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
tr > th,
td {
  vertical-align: center;
  text-align: center;
}
.no-border td {
  border: none;
}
</style>
